import { useState, useEffect, useRef } from 'react';

export default function useIntersectionVisible({
  threshold = 0.1,
  rootMargin = '0px',
  triggerOnce = false
} = {}) {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);
  const observerRef = useRef(null);
  
  useEffect(() => {
    if (typeof window === 'undefined' || !elementRef.current) return;
    
    if (observerRef.current) observerRef.current.disconnect();
    
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        const newIsVisible = entry.isIntersecting;
        setIsVisible(newIsVisible);
        
        if (triggerOnce && newIsVisible && observerRef.current) {
          observerRef.current.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    
    observerRef.current.observe(elementRef.current);
    
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [threshold, rootMargin, triggerOnce]);
  
  return [elementRef, isVisible];
}